import React from 'react';
import { useScrollReveal } from '../../hooks';
import { TextArrowLink } from '../../components';
import { CanvasFigure } from '../../components/figures/CanvasFigure';
import { SectionHeader } from '../ThesisSection/layouts';
import { closedLoop, LOOP_REST } from './loop';

export function ParadigmSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} id="paradigm" className="relative bg-background-secondary py-24 md:py-36">
      <div className="max-w-wide mx-auto px-6 sm:px-10 md:px-12">
        <SectionHeader
          label="A new paradigm"
          title="Systems that learn in production."
          description="Most AI is configured once and deployed. We build closed loops that learn from production."
          isVisible={isVisible}
          labelColor="pink"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-xl mx-auto lg:max-w-none">
          <div
            className={`h-[300px] lg:h-[360px] opacity-0 ${isVisible ? 'animate-fade-up' : ''}`}
            style={{ animationDelay: '0.3s' }}
          >
            <CanvasFigure draw={closedLoop} rest={LOOP_REST} />
          </div>

          <div
            className={`space-y-5 opacity-0 ${isVisible ? 'animate-fade-up' : ''}`}
            style={{ animationDelay: '0.4s' }}
          >
            <p className="font-body text-body text-foreground-tertiary leading-relaxed">
              Each model decides inside the request. Answers it is sure of act straight away, and the ones it is
              unsure of go to your team.
            </p>
            <p className="font-body text-body text-foreground-tertiary leading-relaxed">
              Their reviews train the next version, and a gate checks it against the one before. It serves only
              once it passes, so each turn of the loop keeps what the last one learned.
            </p>
            <p className="font-body text-body text-foreground-tertiary leading-relaxed">
              <em>Every decision you review makes the next version better.</em>
            </p>

            <div className="pt-4 flex justify-end">
              <TextArrowLink href="/blog/closing-the-loop-without-slowing-the-request">How we close the loop</TextArrowLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ParadigmSection;
